import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import VAlertCompat from './VAlertCompat'
import VAutocompleteCompat from './VAutocompleteCompat'
import VBadgeCompat from './VBadgeCompat'
import VBtnCompat from './VBtnCompat'
import VBreadcrumbsCompat from './VBreadcrumbsCompat'
import VCardCompat from './VCardCompat'
import {
  VCardActionsCompat,
  VCardSubtitleCompat,
  VCardTextCompat,
  VCardTitleCompat
} from './VCardSectionCompat'
import VChipCompat from './VChipCompat'
import VComboboxCompat from './VComboboxCompat'
import VDataTableCompat from './VDataTableCompat'
import VDatePickerCompat from './VDatePickerCompat'
import VDialogCompat from './VDialogCompat'
import {
  VExpansionPanelCompat,
  VExpansionPanelContentCompat,
  VExpansionPanelHeaderCompat,
  VExpansionPanelsCompat
} from './VExpansionPanelCompat'
import VFormCompat from './VFormCompat'
import VIconCompat from './VIconCompat'
import VImgCompat from './VImgCompat'
import VListCompat from './VListCompat'
import VListItemCompat from './VListItemCompat'
import VListItemContentCompat from './VListItemContentCompat'
import {
  VListItemActionCompat,
  VListItemSubtitleCompat,
  VListItemTitleCompat
} from './VListItemSectionCompat'
import VMenuCompat from './VMenuCompat'
import VNavigationDrawerCompat from './VNavigationDrawerCompat'
import VOverflowBtnCompat from './VOverflowBtnCompat'
import VOverlayCompat from './VOverlayCompat'
import VPaginationCompat from './VPaginationCompat'
import VRowCompat from './VRowCompat'
import VSelectCompat from './VSelectCompat'
import {
  VCheckboxCompat,
  VRadioCompat,
  VRadioGroupCompat,
  VSwitchCompat
} from './VSelectionControlCompat'
import VSimpleTableCompat from './VSimpleTableCompat'
import VSnackbarCompat from './VSnackbarCompat'
import VStepperCompat from './VStepperCompat'
import VStepperHeaderCompat from './VStepperHeaderCompat'
import VStepperStepCompat from './VStepperStepCompat'
import VTabCompat from './VTabCompat'
import VTabItemCompat from './VTabItemCompat'
import VTabsCompat from './VTabsCompat'
import VTabsItemsCompat from './VTabsItemsCompat'
import VTextFieldCompat from './VTextFieldCompat'
import VTextareaCompat from './VTextareaCompat'
import VTooltipCompat from './VTooltipCompat'

export const defaultLightThemeColors = {
  primary: '#253D81',
  secondary: '#06A8F3',
  tertiary: '#304788',
  quaternary: '#213261',
  accent: '#FF8200',
  error: '#FF0000',
  background: '#EFF1F3',
  secondaryHighlight: '#E5F3FF',
  link: '#0066c0',
  lightHighlightBackground: '#e5f3ff',
  headerPrimary: '#000000',
  headerSecondary: '#111111'
}

export default createVuetify({
  components: {
    ...components,
    VAlert: VAlertCompat,
    VAutocomplete: VAutocompleteCompat,
    VBadge: VBadgeCompat,
    VBtn: VBtnCompat,
    VBreadcrumbs: VBreadcrumbsCompat,
    VCard: VCardCompat,
    VCardActions: VCardActionsCompat,
    VCardSubtitle: VCardSubtitleCompat,
    VCardText: VCardTextCompat,
    VCardTitle: VCardTitleCompat,
    VChip: VChipCompat,
    VCombobox: VComboboxCompat,
    VDataTable: VDataTableCompat,
    VDatePicker: VDatePickerCompat,
    VDialog: VDialogCompat,
    VExpansionPanel: VExpansionPanelCompat,
    VExpansionPanelContent: VExpansionPanelContentCompat,
    VExpansionPanelHeader: VExpansionPanelHeaderCompat,
    VExpansionPanels: VExpansionPanelsCompat,
    VForm: VFormCompat,
    VIcon: VIconCompat,
    VImg: VImgCompat,
    VList: VListCompat,
    VListItem: VListItemCompat,
    VCheckbox: VCheckboxCompat,
    VListItemContent: VListItemContentCompat,
    VListItemAction: VListItemActionCompat,
    VListItemSubtitle: VListItemSubtitleCompat,
    VListItemTitle: VListItemTitleCompat,
    VMenu: VMenuCompat,
    VNavigationDrawer: VNavigationDrawerCompat,
    VOverflowBtn: VOverflowBtnCompat,
    VOverlay: VOverlayCompat,
    VPagination: VPaginationCompat,
    VRadio: VRadioCompat,
    VRadioGroup: VRadioGroupCompat,
    VRow: VRowCompat,
    VSelect: VSelectCompat,
    VSimpleTable: VSimpleTableCompat,
    VSnackbar: VSnackbarCompat,
    VStepper: VStepperCompat,
    VStepperHeader: VStepperHeaderCompat,
    VStepperStep: VStepperStepCompat,
    VTab: VTabCompat,
    VTabItem: VTabItemCompat,
    VTabs: VTabsCompat,
    VTabsItems: VTabsItemsCompat,
    VTextField: VTextFieldCompat,
    VTextarea: VTextareaCompat,
    VTooltip: VTooltipCompat,
    VSwitch: VSwitchCompat
  },
  directives,
  icons: {
    defaultSet: 'mdi'
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: defaultLightThemeColors
      }
    }
  },
  // Vuetify 4 defaults to sm:600/md:840/lg:1145/xl:1545/xxl:2138 - master's
  // UI was built against Vuetify 2's sm:600/md:960/lg:1264/xl:1904, which
  // every $vuetify.display.*/mobile-breakpoint-driven behaviour (nav
  // drawer, data table mobile view, dialog fullscreen-on-mobile) assumes.
  // Matches the $grid-breakpoints override applied to Vuetify's own grid
  // CSS in scripts/patch-vuetify-grid-breakpoints.js.
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1264,
      xl: 1904,
      xxl: 2560
    }
  }
})
